<template>
  <v-container class="benefits-section">
    <div class="section-header text-center mb-12">
      <h2 class="section-title">Why Choose Automation?</h2>
      <p class="section-subtitle">Transform your inventory management with these powerful benefits</p>
    </div>
    
    <v-row>
      <v-col
        v-for="(benefit, index) in benefits"
        :key="benefit.id"
        cols="12"
        sm="6"
        md="3"
      >
        <benefit-card
          :title="benefit.title"
          :value="benefit.value"
          :description="benefit.description"
          :icon="benefit.icon"
          :color="benefit.color"
          :delay="index * 100"
        />
      </v-col>
    </v-row>
    
    <v-row justify="center" class="mt-12">
      <v-col cols="12" md="10" lg="8">
        <v-card class="testimonial-card" elevation="0">
          <v-card-text class="pa-8 text-center">
            <v-icon size="48" color="primary" class="mb-4">mdi-format-quote-open</v-icon>
            <p class="testimonial-text">
              "Automated Purchase Orders saved us 20 hours per week. 
              We can now focus on growing our business instead of managing spreadsheets."
            </p>
            <div class="testimonial-author mt-4">
              <strong>Sarah Johnson</strong>
              <br>
              <span class="grey--text">Operations Manager, TechStore Inc.</span>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import BenefitCard from './BenefitCard.vue';

export default {
  name: 'BenefitsGrid',
  
  components: {
    BenefitCard
  },
  
  data() {
    return {
      benefits: [
        {
          id: 'time-saved',
          title: 'Time Saved',
          value: '80%',
          description: 'Reduce manual ordering time dramatically',
          icon: 'mdi-clock-fast',
          color: 'primary'
        },
        {
          id: 'accuracy',
          title: 'Accuracy',
          value: '99%',
          description: 'Eliminate human errors in ordering',
          icon: 'mdi-target',
          color: 'success'
        },
        {
          id: 'cost-reduction',
          title: 'Cost Reduction',
          value: '25%',
          description: 'Optimize inventory levels and reduce waste',
          icon: 'mdi-trending-down',
          color: 'warning'
        },
        {
          id: 'scalability',
          title: 'Scalability',
          value: '∞',
          description: 'Handle unlimited products and suppliers',
          icon: 'mdi-rocket-launch',
          color: 'info'
        }
      ]
    };
  }
};
</script>

<style scoped>
.benefits-section {
  padding: 80px 0;
  background: #ffffff;
  position: relative;
}

.section-header {
  position: relative;
  z-index: 1;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 16px;
}

.section-subtitle {
  font-size: 1.2rem;
  color: #546e7a;
  font-weight: 300;
  max-width: 600px;
  margin: 0 auto;
}

.testimonial-card {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-radius: 20px;
  position: relative;
  overflow: hidden;
}

.testimonial-card::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.3) 0%, transparent 70%);
  animation: shimmer 3s ease-in-out infinite;
}

@keyframes shimmer {
  0%, 100% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(-30px, 30px);
  }
}

.testimonial-text {
  font-size: 1.4rem;
  font-style: italic;
  color: #37474f;
  line-height: 1.8;
  max-width: 700px;
  margin: 0 auto;
}

.testimonial-author {
  font-size: 1rem;
  color: #546e7a;
}

@media (max-width: 960px) {
  .benefits-section {
    padding: 60px 0;
  }
  
  .section-title {
    font-size: 2rem;
  }
  
  .testimonial-text {
    font-size: 1.2rem;
  }
}
</style> 